import type { ReadonlyDeep } from 'type-fest';
import type { DataItem as JobsAirRoadTableDataItem } from '@/components/tables/JobsAirRoadTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { getStrCell } from '@/utils/file';
import * as oneTrackingJobHelpers from '@/helpers/trackingJob/oneTrackingJob';

export function getTableItem(
  bookingArJob: ReadonlyDeep<
    openapi.JobsToAirroad2ListContentOpenapi['results'][0]
  >,
): JobsAirRoadTableDataItem {
  const { jobId, jobDate } =
    oneTrackingJobHelpers.getJobIdAndJobDate(bookingArJob);

  return {
    id: bookingArJob.id,
    jobId,
    jobDate,
    customerCode: getStrCell(bookingArJob.customer),
    stop1: getStrCell(bookingArJob.stops[0]?.name),
    stop2: getStrCell(bookingArJob.stops[1]?.name),
    stop3: getStrCell(bookingArJob.stops[2]?.name),
    reference1: getStrCell(bookingArJob.reference_1),
    reference2: getStrCell(bookingArJob.reference_2),
    reference3: getStrCell(bookingArJob.reference_3),
    fold: {
      bookingArJob,
    },
  };
}

export function getTableData(
  airRoadBookingJobsData:
    | ReadonlyDeep<openapi.JobsToAirroad2ListContentOpenapi>
    | undefined,
): JobsAirRoadTableDataItem[] {
  const _jobsAirRoadTableData: JobsAirRoadTableDataItem[] = [];
  if (!airRoadBookingJobsData?.results.length) {
    return _jobsAirRoadTableData;
  }
  airRoadBookingJobsData.results.forEach(function (bookingArJob) {
    _jobsAirRoadTableData.push(getTableItem(bookingArJob));
  });
  return _jobsAirRoadTableData;
}
